const URL = process.env.NODE_ENV === 'production' ? 'https://tkycapi.ddtmx.com/' : 'https://tkycapi.ddtmx.com/';
export default URL;